export const TwoStarsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 74 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.5 19L49.1839 24.1824H54.6329L50.2245 27.3853L51.9084 32.5676L47.5 29.3647L43.0916 32.5676L44.7755 27.3853L40.3671 24.1824H45.8161L47.5 19Z"
        fill="currentColor"
      />
      <path
        d="M26.5 19L28.1839 24.1824H33.6329L29.2245 27.3853L30.9084 32.5676L26.5 29.3647L22.0916 32.5676L23.7755 27.3853L19.3671 24.1824H24.8161L26.5 19Z"
        fill="currentColor"
      />
    </svg>
  );
};
